import { render, staticRenderFns } from "./PaymentWindow.vue?vue&type=template&id=a8f23414"
import script from "./PaymentWindow.vue?vue&type=script&lang=js"
export * from "./PaymentWindow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports